import { createContext } from "react";
export const Maincontext = createContext();
